import React, { useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import { useTheme } from '@material-ui/core/styles';

const LoadingPage = ({ loading }) => {
  const theme = useTheme();
  let [color] = useState(theme.palette.incorta?.main ?? '');
  const pageStyle = {
    position: 'relative',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  };

  return (
    <div style={pageStyle}>
      <img src="/images/incorta-logo.png" alt="Incorta Logo" style={{ marginBottom: '2rem' }} />
      <BeatLoader
        color={color}
        loading={loading}
        size={20}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default LoadingPage;
